import {useNavigateWithQueryParams} from "@App/hooks/useNavigateWithQueryParams";
import {useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "@reduxjs/toolkit";
import {useServices} from "@App/hooks/api/useServices";
import {useEffect} from "react";
import {actionCreators, State} from "@App/state";

/**
 * Abstraction hook to keep the funnel pages clean.
 * Provides a service and the navigate method.
 * @param slug
 */
export const useServiceFunnel = (slug: string) => {

    const {navigateWithQuery} = useNavigateWithQueryParams()

    // get the service from the store
    const service = useSelector((state: State) => state.orders.service)

    // if service is not set, fetch it from the api
    const dispatch = useDispatch();
    const {chooseService} = bindActionCreators(actionCreators, dispatch)

    const {services} = useServices()

    useEffect(() => {
        if (!service && services) {
            chooseService(services.find(service => service.slug === slug))
        }
    }, [services])


    return {
        service,
        navigateWithQuery
    }
}
